 "use client";

import { cn } from "@/lib/utils";
import { useState } from "react";

type Props = {
  src: string;
  alt: string;
  /** Paper-style frame for PDF; light panel for in-app UI */
  variant?: "document" | "panel";
  className?: string;
};

export function FeatureScreenshotFrame({ src, alt, variant = "document", className }: Props) {
  const isDoc = variant === "document";
  const [missing, setMissing] = useState(false);
  return (
    <div
      className={cn(
        "overflow-hidden rounded-xl shadow-[0_22px_50px_-18px_rgba(15,23,42,0.35)] ring-1 ring-slate-900/10",
        isDoc ? "border border-slate-200 bg-white" : "border border-slate-200/90 bg-slate-50",
        className
      )}
    >
      {/* eslint-disable-next-line @next/next/no-img-element -- static marketing PNGs */}
      {!missing ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setMissing(true)}
          className="block h-auto w-full max-w-full align-top"
        />
      ) : (
        <div className="flex min-h-[260px] items-center justify-center bg-gradient-to-b from-white to-slate-50 p-6 text-center">
          <p className="max-w-xs text-sm text-slate-500">Feature screenshot unavailable locally. Replace files in `public/marketing` to restore this image.</p>
        </div>
      )}
    </div>
  );
}
